export default {
    // Modal
    OPEN_MODAL: 'open-modal',
    CLOSE_MODAL: 'close-modal',
    HIDE_MODAL: 'hide-modal',
    SHOW_MODAL: 'show-modal',

    // Scroll
    SCROLL_BOTTOM: 'scroll-bottom',

    // Misc
    SEARCH_POST: 'search-post',
    SEARCH_CREATOR: 'search-creator',
}
